import { AuthService } from './../../../../services/auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import {Router} from '@angular/router';
import {IStreet} from '../../../../models/street.model';
import {IDistrict} from '../../../../models/district.model';
import {IDomain} from '../../../../models/domain.model';
import {ICity} from '../../../../models/city.model';
import {ICountry} from '../../../../models/country.model';
import {User} from '../../../../models/user.model';
import {UserService} from '../../../../services/user.service';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import {CommerciauxService} from "../../../../services/commerciaux.service";
import {DatePipe} from "@angular/common";
import { TemporaryUserResetEmail } from '../../../../models/temporaryuseresetemail.model';
import { ResetUserEmailService } from '../../../../services/resetuseremail.service';

@Component({
  selector: 'app-user-new-version',
  templateUrl: './user-new-version.component.html',
  styleUrls: ['./user-new-version.component.scss']
})
export class UserNewVersionComponent implements OnInit {

  private usersTmp: User[];
    // @ts-ignore
    users: User[] = [];
    userFilter: User[] = [];
    // @ts-ignore
    currentUser: User = [];
  
    // @ts-ignore
    public year: number;
    // @ts-ignore
    public month: number;
    // @ts-ignore
    public day: number;
    // @ts-ignore
    public maxDate: Date;
    // @ts-ignore
    public minDate: Date;
  
    street: IStreet[] = [];
    district: IDistrict[] = [];
    domain: IDomain[] = [];
    cities: ICity[] = [];
    countries: ICountry[] = [];
  
    /*
   -----------------------------         for all page attribute    --------------------------------
   */
    page: number = 1;
    count: number = 0;
    tableSize: number = 10;
    tableSizes: any = [10, 15, 30, 50];
    search: any;
    seller = false;
    perPage = 10;
  
    userForm : FormGroup;
    /*
    end for all page
     */
    sorted = false;
    sorted1 = false;
    sorted2 = false;
    sorted3 = false;
    sorted4 = false;
    sorted5 = false;
    sorted6 = false;
    sorted7 = false;
    sorted9 = false;
  
    isCommercial = false;
    isStillCommercial = false;
    emailForm: FormGroup;
    constructor(private commerciauxService : CommerciauxService,private datePipe: DatePipe,
      private router: Router, private resetUserEmailService: ResetUserEmailService,
      private fb: FormBuilder,
      private userService: UserService,
      private authService: AuthService) { 
        this.emailForm = this.fb.group({
          newEmail: ['', [Validators.required, Validators.email]]
        });
      }
  
    get f2() { return this.userForm.controls; }
    temporaryUserResetEmail!: TemporaryUserResetEmail;
    getTemporaryUser(c: any){
     // console.log(c)
      this.temporaryUserResetEmail = new TemporaryUserResetEmail();
      this.temporaryUserResetEmail.firstName = c.firstname;
      this.temporaryUserResetEmail.lastName = c.lastname;
      this.temporaryUserResetEmail.username = c.username;
      this.temporaryUserResetEmail.oldEmail = c.email;
      this.temporaryUserResetEmail.indicatif = c.indicatif;
      this.temporaryUserResetEmail.phoneNumber = c.phoneNumber;
    }
  
    saveEmail() {
      if (this.emailForm.valid) {
        const newEmail = this.emailForm.value.newEmail;
        this.temporaryUserResetEmail.newEmail = newEmail;
        // console.log("Email temporaire à modifier");
        // console.log(this.temporaryUserResetEmail);
        this.resetUserEmailService.resetEmailAdressSendLik(this.temporaryUserResetEmail).subscribe({
          next: (res) => {
            debugger;
           // console.log(res);
            Swal.fire({
              title: 'Réussi',
              text: 'Email de réinitialisation envoyée avec succès.',
              icon:'success',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigate(['/users']);
              }
            })
          },
          error: (error) => {
           // console.error(error);
            Swal.fire({
              title: 'Erreur',
              text: 'Une erreur est survenue lors de la modification de l\'email',
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }
        })
        // Logique pour sauvegarder l'email
        this.emailForm.reset(); // Réinitialiser le formulaire
      }
    }
  
    ngOnInit(): void {
  
      this.authService.isAuthenticated().subscribe(isAuthenticated => {
        this.loadUsers();
        this.year  = new Date().getFullYear();
        this.month = new Date().getMonth();
        this.day   = new Date().getDate();
        this.maxDate  = new Date(this.year - 15, this.month, this.day);
        this.minDate = new Date(1911, 1, 1);
  
        this.userForm = this.fb.group({
            'lastname': ['', [Validators.required, Validators.maxLength(40), Validators.pattern('^[A-Za-zéàèîôêûïëüö -]+$')]],
            'firstname': ['', [Validators.required,  Validators.maxLength(80), Validators.pattern('^[A-Za-zéàèîôêûïëüö -]+$')]],
            'date' : ['', [Validators.required]],
            'gender' : ['', [ Validators.required]],
            'residenceCity': ['', [Validators.required]],
            'residenceCountry': ['', [Validators.required]],
            'email': ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            'phoneNumber': ['', [Validators.required, Validators.pattern('(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})')]],
            'password': ['', [Validators.minLength(8), Validators.required, Validators.pattern('^[a-z0-9]+$')]],
            'passwordrepeat': ['',[Validators.required, Validators.pattern('^[a-z0-9]+$')]]
          },
          {
            Validators : this.userService.passwordMacthValidator("password","passwordrepeat")
          }
        );
      },error=>{
        this.router.navigate(['/login']);
      });
  
  
  
  
    }
  
    loadUsers = () => {
      this.userService.getUsers().subscribe(data => {
          this.users = data;
          // console.log("-_-_-_-_-_-_-_-_-_-_-_-_-_-_-");
          // console.log(this.users);
          this.userFilter = this.users;
          this.users.forEach(value => {
            value.sellerAuthorization = (value.sellerAuthorization == null || value.sellerAuthorization == 'Client') ? 'Client' : 'Vendeur';
            this.commerciauxService.getCommerciauxWithCode(value.username).subscribe(rs =>{
              if (rs != null) {
                value.commercialID = rs.commercialID;
              }
            });
          });
        this.usersTmp = this.users;
  
      }, (err) => {
        });
      this.seller = false;
    }
  
    loadUserSeller = () => {
      this.userService.getUserSeller()
        .subscribe(data => {
          this.users = data;
          this.usersTmp = data;
        }, (err) => {
        });
      this.seller = true;
    }
    clear()
    {
      this.userForm.reset();
    }
  
  
    deleteUser(id: any) {
      Swal.fire({
        title: 'SUPPRESSION',
        text: 'Voulez-vous vraiment supprimer cet utilisateur ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'OUI',
        denyButtonText: `NON`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.userService.deleteUser(id).subscribe(
            rs => {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'L\'utilisateur supprimé avec succès"',
                showConfirmButton: false,
                timer: 1500
              });
              this.loadUsers();
            }
          );
        } else if (result.isDenied) {
          Swal.fire({
            icon: 'error',
            text: 'Suppression annulée',
          })
        }
      });
    }
  
    onViewUser(id: any) {
      this.userService.getidUser(id).subscribe(rs => {
        this.currentUser = rs;
      });
      this.router.navigate(['user-details', id]);
    }
  
  
    verifyPassword() {
      return this.userForm.controls['password'].value != this.userForm.controls['passwordrepeat'].value;
    }
  
    /*
      -----------------------------          for all page methodes      -----------------------------
       */
  
      disableEndDate = true;
    displayError = false;
    //Récupération de la date de début
    getBeginDate(event:any){
      this.beginDate=event.target.value;
      if(this.beginDate){
        this.disableEndDate = false;
        if(this.beginDate > this.endDate){
          this.displayError = true;
        }else{
          this.displayError = false;
        }
      }else{
        this.disableEndDate = true;
      }
    }
    // Récupération de la date de fin
    getEndDate(event){
      this.endDate=event.target.value;
    }
  
  
    /*searchFilter($event: KeyboardEvent) {
      this.userService.getUsers().subscribe(data => {
        this.users = data;
        this.users = this.users.filter(value =>
          value?.firstname?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.lastname?.toLowerCase().includes(this.search.toUpperCase()) ||
          value?.username?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.gender?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.address?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.residenceCity?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.residenceCountry?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.nationality?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.sellerAuthorization?.toUpperCase().includes(this.search.toUpperCase()) ||
          value?.email?.toUpperCase().includes(this.search.toUpperCase()));
      }, (err) => {
        console.log('-----> err', err);
      });
    }*/
  
    searchFilter($event: KeyboardEvent) {
      this.users = this.userFilter.filter(value =>
        value?.firstname?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.lastname?.toLowerCase().includes(this.search.toUpperCase()) ||
        value?.username?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.gender?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.address?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.residenceCity?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.residenceCountry?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.nationality?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.sellerAuthorization?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.email?.toUpperCase().includes(this.search.toUpperCase())
      );
      // console.log("Resultat recherche ...");
      // console.log(this.users);
    }
  
    displayPerPage(value: any) {
      this.perPage = parseInt(value, 10);
    }
    /*
    end for all page
     */
    activeAccount(currentUser: User) {
      currentUser.activated = true;
      currentUser.profilPhoto = null;
      currentUser.photoSelfie = null;
      currentUser.iphotoVerso = null;
      currentUser.iphotoRecto = null;
      this.userService.updateUser(currentUser).subscribe(rs => {
        // console.log("Utilisateur activé........#");
        // console.log(rs);
        // console.log("Utilisateur activé........#");
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Le compte de l\'utilisateur  ' + currentUser.firstname + ' a bien été activé',
          showConfirmButton: false,
          timer: 1500
        });
        this.loadUsers();
      });
    }
    lockAccount(currentUser: User) {
      currentUser.activated = false;
      currentUser.profilPhoto = null;
      currentUser.photoSelfie = null;
      currentUser.iphotoVerso = null;
      currentUser.iphotoRecto = null;
      this.userService.updateUser(currentUser).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Le compte de l\'utilisateur  ' + currentUser.firstname + ' a bien été désactivé',
          showConfirmButton: false,
          timer: 1500
        });
        this.loadUsers();
      });
    }
  
    commercial(id:any) {
  
      let newCommercial;
      this.userService.getidUser(id).subscribe(nwuser => {
        newCommercial=nwuser;
        if(!newCommercial.commercial){
          Swal.fire({
            title: 'Nouveau commercial',
            text: 'Voulez-vous ajouter '+newCommercial.firstname +' '+ newCommercial.lastname+' en tant que commercial ?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'OUI',
            denyButtonText: `NON`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.userService.updateUserToBecomeCommercial(id).subscribe(rs => {
                  Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: newCommercial.firstname +' '+ newCommercial.lastname+' est désormais commercial.',
                    showConfirmButton: false,
                    timer: 3500
                  });
                  //this.loadUsers();
                  this.users.forEach(element => {
                    if (element.id === id) {
                      element.commercial = true;
                    }
                  })
                },error => {
                  Swal.fire({
                    icon: 'error',
                    position: 'top-end',
                    title: newCommercial.firstname +' '+ newCommercial.lastname+' est déjà commercial.',
                    showConfirmButton: false,
                    timer: 3500
                  })
                }
              );
            } else if (result.isDenied) {
              Swal.fire({
                icon: 'error',
                text: 'Opération annulée',
              })
            }
          });
        }else {
          Swal.fire({
            icon: 'error',
            position: 'top-end',
            title: newCommercial.firstname +' '+ newCommercial.lastname+' est déjà commercial.',
            showConfirmButton: false,
            timer: 3500
          })
        }
  
      })
    }
  
    sort1() {
      if(this.sorted1 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.username > b.username ? 1 : a.username < b.username ? -1 : 0)
        this.sorted1 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.username < b.username ? 1 : a.username > b.username ? -1 : 0)
        this.sorted1 = false;
  
      }
    }
    sort2() {
      if(this.sorted2 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.lastname.toLowercase  > b.lastname.toLowercase ? 1 : a.lastname < b.lastname ? -1 : 0)
        this.sorted2 = true;
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.lastname.toLowercase  < b.lastname.toLowercase  ? 1 : a.lastname > b.lastname ? -1 : 0)
        this.sorted2 = false;
      }
    }
    sort3() {
      if(this.sorted3 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.firstname > b.firstname ? 1 : a.firstname < b.firstname ? -1 : 0)
        this.sorted3 = true;
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.firstname < b.firstname ? 1 : a.firstname > b.firstname ? -1 : 0)
        this.sorted3 = false;
      }
    }
    sort4() {
      if(this.sorted4 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
        this.sorted4 = true;
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
        this.sorted4 = false;
      }
    }
  
  
    exportexcel(fileName): void {
      /* table id is passed over here */
      let element = document.getElementById('excel-table');
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName);
  
    }
  
    sort5() {
      if(this.sorted5 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
        this.sorted5 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
        this.sorted5 = false;
  
      }
    }
  
    sort6() {
      if(this.sorted6 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.gender > b.gender ? 1 : a.gender < b.gender ? -1 : 0)
        this.sorted6 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.gender < b.gender ? 1 : a.gender > b.gender ? -1 : 0)
        this.sorted6 = false;
  
      }
    }
  
    sort7() {
      if(this.sorted7 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.activated > b.activated ? 1 : a.activated < b.activated ? -1 : 0)
        this.sorted7 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.activated < b.activated ? 1 : a.activated > b.activated ? -1 : 0)
        this.sorted7 = false;
  
      }
    }
  
  
    sort9() {
      if(this.sorted9 == false) {
        // @ts-ignore
        this.users.sort((a, b) => a.sellerAuthorization > b.sellerAuthorization ? 1 : a.sellerAuthorization < b.sellerAuthorization ? -1 : 0)
        this.sorted9 = true;
  
      } else {
        // @ts-ignore
        this.users.sort((a, b) => a.sellerAuthorization < b.sellerAuthorization ? 1 : a.sellerAuthorization > b.sellerAuthorization ? -1 : 0)
        this.sorted9 = false;
  
      }
    }
  
    /*
    filtre par date
     */
  
    beginDate: string = null;
    endDate: string = null;
  
    filter() {
      //console.log(this.endDate)
      if (this.endDate == null || this.beginDate== null) {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
          showConfirmButton: false,
          timer: 3500
        })
        return;
      }
      if (this.endDate!= null && this.beginDate!= null && this.beginDate < this.endDate) {
        const dateString = this.endDate;
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
        this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
        /*this.users = this.usersTmp;*/
        this.users = this.userFilter.filter((rev) => {
          let date = this.datePipe.transform(rev.createdAt, 'yyyy-MM-dd')
          return (date >= this.beginDate &&  date  <= this.endDate);
        });
      }
    }
  
    resetFilter() {
      this.loadUsers();
      this.beginDate = null;
      this.endDate = null;
    }

}
